const compatModules = {};import * as Mod1 from "./discourse/initializers/waze-session-initializer";
compatModules["discourse/initializers/waze-session-initializer"] = Mod1;

export * as discourse$initializers$waze__session__initializer$$__module from "./discourse/initializers/waze-session-initializer";
export {
default as discourse$initializers$waze__session__initializer$$default
} from "./discourse/initializers/waze-session-initializer";
export default compatModules;
